// src/components/CoinIcon.tsx
import React, { FC, useEffect, useState } from 'react';

interface BankIconProps {
    symbol?: string;
    className?: string;
}

const loadIcon = async (symbol: string) => {
    try {
        const icon = await import(`assets/banks/${symbol}.svg`);
        return icon.default; // Assuming the SVG is exported as default
    } catch (error) {
        const icon = await import(`assets/banks/Default.svg`);
        return icon.default;
    }
};

const _BankIcon: FC<BankIconProps> = (props) => {
    const [iconPath, setIconPath] = useState<string | null>(null);

    useEffect(() => {
        if (props.symbol) {
            const fetchIcon = async () => {
                const path = await loadIcon(props.symbol!);
                setIconPath(path);
            };

            fetchIcon();
        }
    }, [props.symbol]);

    if (!props.symbol) return <></>;
    return <img className={`w-6 h-6 ${props.className}`} src={iconPath || ''} alt={props.symbol} />;
};

export default _BankIcon;
